export type SetApplicationStatusAction =
  | "take"
  | "approve"
  | "revision"
  | "send-offer"
  | "confirm-payment"
  | "send-lead-signature"
  | "signing-all-documents"
  | "refusal"
  | "release-application";

type SetApplicationStatusResponseMessage = {
  success: string;
  error: string;
};

export type ResponseErrorDataType = {
  message: string;
  success: boolean;
};

export type ResponseErrorType = {
  data: ResponseErrorDataType;
  status: number;
};
export type ResponseMetaType = { request: Request; response: Response };

export type ApiResponseType = {
  error: ResponseErrorType;
  meta: ResponseMetaType;
};

export const setApplicationBankStatusResponseMessage: Record<
  SetApplicationStatusAction,
  SetApplicationStatusResponseMessage
> = {
  take: {
    success: "Заявка взята в работу",
    error: "Не удалось взять в работу заявку",
  },
  approve: {
    success: "Заявка предварительно одобрена",
    error: "Не удалось предварительно одобрить",
  },
  revision: {
    success: "Заявка отправлена на доработку",
    error: "Не удалось отправить на доработку",
  },
  "send-offer": {
    success: "Предложение отправлено",
    error: "Не удалось отправить предложение",
  },
  "confirm-payment": {
    success: "Оплата подтверждена",
    error: "Не удалось подтвердить оплату",
  },
  "send-lead-signature": {
    success: "Заявка отправлена на подписание руководителю",
    error: "Не удалось отправить на подписание руководителю",
  },
  "signing-all-documents": {
    success: "Документы успешно подписаны",
    error: "Не удалось подписать документы",
  },
  refusal: {
    success: "Отказано",
    error: "Не удалось отказать",
  },
  "release-application": {
    success: "Заявка успешно выпущена",
    error: "Не удалось выпустить заявку",
  },
};
